<template>
    <div class="ds-ex-filter-wrap" v-click-outside="close" @keydown.esc.stop="close">
        <button
            type="button"
            class="ds-ex-filter"
            :class="{ 'is-selected': selectedCount > 0, 'is-open': isOpen }"
            aria-haspopup="listbox"
            :aria-expanded="isOpen"
            @click="isOpen = !isOpen"
        >
            <span>{{ label }}</span>
            <span v-if="multiple && selectedCount" class="ds-ex-filter-count">{{ selectedCount }}</span>
            <span v-else-if="!multiple && selectedCount" class="ds-ex-filter-value">· {{ selectedNames }}</span>
            <svg class="ds-ex-chevron" :class="{ 'is-open': isOpen }" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
        </button>
        <div v-if="isOpen" class="ds-glass-menu ds-ex-filter-menu" role="listbox" :aria-multiselectable="multiple" :aria-label="label">
            <div v-if="multiple" class="ds-glass-menu-heading">Можно выбрать несколько</div>
            <button
                v-for="option in options"
                :key="option.id"
                type="button"
                role="option"
                class="ds-glass-menu-item"
                :class="{ 'is-selected': isChecked(option.id) }"
                :aria-selected="isChecked(option.id)"
                @click="toggle(option.id)"
            >
                <span class="ds-glass-menu-item-label">{{ option.name }}</span>
                <svg v-if="isChecked(option.id)" class="ds-ex-select-check" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L20 7" /></svg>
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

// Фильтр с выбором из короткого списка: одиночный (повторный клик снимает выбор) или множественный.
const props = withDefaults(defineProps<{
    label: string
    options: Array<{ id: string, name: string }>
    multiple?: boolean
}>(), { multiple: false })

const selected = defineModel<string[]>({ default: () => [] })
const isOpen = ref(false)

const selectedCount = computed(() => selected.value.length)
const selectedNames = computed(() => props.options.filter(option => selected.value.includes(option.id)).map(option => option.name).join(', '))
const isChecked = (id: string) => selected.value.includes(id)

function toggle(id: string) {
    if (props.multiple) {
        selected.value = isChecked(id) ? selected.value.filter(item => item !== id) : [...selected.value, id]
        return
    }
    selected.value = isChecked(id) ? [] : [id]
    isOpen.value = false
}

function close() {
    isOpen.value = false
}
</script>
